let cookies = [];

const getAllCookies = ()=>{
    let cookiesString = document.cookie;
    let cookiesArray = cookiesString.split(";")
    let cookie = []
    for(let i in cookiesArray){
        cookiesArray[i] =  cookiesArray[i].trim();
        cookie = cookiesArray[i].split("=");
        cookies[cookie[0]] = cookie[1];
    }
}

getAllCookies();

export const setCookie = (name, value)=>{
    document.cookie = `${name}=${value}; path=/`;
    getAllCookies();
}

export const getCookie = (name)=>{
    if(cookies[name])
        return cookies[name];
    else
        return null;
}
export const removeCookie = (name) =>{
    if(cookies[name]){
        document.cookie = `${name}=;expires=Sun, 20 Aug 2000 12:00:00 UTC; path=/`;
        getAllCookies();
        if(cookies[name])
            return false 
    }
        return true
}
